import { render } from "./Aluminium.vue?vue&type=template&id=055f7a58"
import script from "./Aluminium.vue?vue&type=script&lang=js"
export * from "./Aluminium.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__